// A modal sheet: a <dialog> that rises from the bottom on a phone and sits
// in the middle on a wider screen (the .picker-sheet rules in index.css).
// Focus stays inside it; ×, Escape and a tap outside close it. Used by the
// Recipes library's filters and Add (slice 7a); the Plan picker has its own
// header and uses the same CSS.
import { useEffect, useRef, type ReactNode } from "react";
import { COLORS, FONT_SIZE, SPACE } from "../lib/constants";
import { roundButton } from "./plan/planStyles";

export function Sheet({ title, onClose, children, footer }: { title: string; onClose: () => void; children: ReactNode; footer?: ReactNode }) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const dialog = ref.current;
    if (dialog && !dialog.open) dialog.showModal();
    return () => dialog?.close();
  }, []);
  return (
    <dialog
      ref={ref}
      className="picker-sheet mp-sans"
      aria-label={title}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
      onClick={(e) => e.target === ref.current && onClose()}
    >
      <div style={{ display: "flex", alignItems: "center", gap: SPACE.xl, padding: "var(--space-xl) var(--space-xxl)", borderBottom: `1px solid ${COLORS.line}` }}>
        <h2 style={{ flex: 1, margin: 0, fontFamily: "var(--font-serif)", fontSize: FONT_SIZE.h3, fontWeight: 600 }}>{title}</h2>
        <button type="button" aria-label="Close" onClick={onClose} style={roundButton}>
          ×
        </button>
      </div>
      <div style={{ flex: 1, overflowY: "auto", padding: "var(--space-xl) var(--space-xxl) var(--space-x4)" }}>{children}</div>
      {footer && <div style={{ padding: "var(--space-md) var(--space-xxl) var(--space-xl)", borderTop: `1px solid ${COLORS.line}` }}>{footer}</div>}
    </dialog>
  );
}
